import { Button } from "../../../../../generics/button";
import { Input } from "../../../../../generics/input-group";

export const MidiaModal = () => {
  return (
    <div>
      <form className="flex flex-col items-end">
        <Input name="Nome da mídia" />
        <Input name="Usuário" />
        <Input name="Endereço do usuário" />
        <div className="mb-4 mt-2 flex h-8 w-full items-center justify-between gap-4">
          <p className="w-2/6 font-medium text-gray-700">Situação: </p>
          <select className="h-full w-full bg-gray-200 px-1 py-2">
            <option value="Todos">Todos</option>
          </select>
        </div>
        <Button name="Salvar" width="w-2/6" />
      </form>
    </div>
  );
};
